import React from 'react';
import './App.css';
import { OptOut } from './components/OptOut/OptOut';
import ErrorHandler from './components/ErrorHandler/ErrorHandler';

const App = () => (
  <div className="App">
    <ErrorHandler>
      <OptOut />
    </ErrorHandler>
  </div>
);

export default App;
